import constate from 'constate';
import { useState } from 'react';

function useFlowBuilderAssistant() {
  const [isAssistantOpen, setIsAssistantOpen] = useState(false);
  return {
    isAssistantOpen,
    setIsAssistantOpen,
  };
}

export const [FlowBuilderAssistantProvider, useFlowBuilderAssistantContext] =
  constate(useFlowBuilderAssistant);
